import axios from "axios";
import React, { useEffect, useState,useRef } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Modal,
  Button,
  Badge,
  Dropdown,
  ProgressBar,
  Alert,
  Spinner,
} from "react-bootstrap";
import swal from "sweetalert";
import { Link,useHistory } from "react-router-dom";
import Riderdetails from "./RiderAcceptDetails";
import Baseurl from "../../../Baseurl";
function RiderApplied() {
  const history=useHistory()
  //const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 25;
  const activePag = useRef(0);
  const [data, setData] = useState([]);
  const [searchItem, setSearchItem] = useState("Name");
  const [searchVehicleType, setSearchVehicleType] = useState("Auto");
  const [show, setShow] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [allriders, setallriders] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const searchObject = ["Name", "Phone Number", "OnBoard ID", "Vehicle Type"];
  const VehicleTypes = ["Auto", "SUV/MUV", "Sedan", "Hatch Back","Tata Ace","PickUp 8ft","Tata 407"];
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  function getData(length){
    axios
    .get(Baseurl.baseurl + `/rider/get-all-not-assigned-riders/${length}`)
    .then((response) => {
      if(response.data.status)
      {
       
        // setallriders(response.data.riders.reverse());
        // setSearchData(response.data.riders);
        setallriders(
          (oldArray) => oldArray.concat(response.data.riders),
          () => {}
        );
        setSearchData(
          (oldArray) => oldArray.concat(response.data.riders),
          () => {}
        );
        setData(document.querySelectorAll("#job_data tbody tr"))
      }
      else
      {
        swal("No More Data", "", "error", {
          button: "Done",
          timer: 1000,
        });
      }
      setSpinner(false);  
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  }
  useEffect(() => {
    getData(allriders.length)
  }, []);
  const passdata = () => {
    handleShow();
  };
  function isNumeric(value) {
    return /^-?\d+$/.test(value);
  }
  function searchRider(value) {
  
    if (isNumeric(value)) {
      if(value.length===6 && searchItem==="OnBoard ID")
      {
        let searchData = {
          query: value,
        };
  
        axios
          .post(
            `${Baseurl.baseurl}/rider/get-applied-onboarding-code`,
            searchData
          )
          .then((res) => {
            setallriders(res.data.data);
            setData(document.querySelectorAll("#job_data tbody tr"))
          })
          .catch((err) => {});
      }
      if(value.length===10 && searchItem==="Phone Number")
        {
          let searchData = {
            query: value,
          };
    
          axios
            .post(
              `${Baseurl.baseurl}/rider/get-applied-rider-phone`,
              searchData
            )
            .then((res) => {
              setallriders(res.data.data);
              setData(document.querySelectorAll("#job_data tbody tr"))
            })
            .catch((err) => {});
        }
    } else {
      let searchData = {
        query: value,
      };

      axios
        .post(
          `${Baseurl.baseurl}/rider/get-applied-rider-name`,
          searchData
        )
        .then((res) => {
          setallriders(res.data.data);
          setData(document.querySelectorAll("#job_data tbody tr"))
        })
        .catch((err) => {});
    }
  }
  function searchByVehicleType(value){
    let searchData = {
      query: value,
    };

    axios
      .post(
        `${Baseurl.baseurl}/rider/get-applied-rider-vehicle-type`,
        searchData
      )
      .then((res) => {
        setallriders(res.data.data);
        setData(document.querySelectorAll("#job_data tbody tr"))
      })
      .catch((err) => {});
  }
  // const [playing, toggle] = useAudio(audioNote);
  return (
    <Col lg={12}>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Riderdetails />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary">Save Changes</Button>
        </Modal.Footer>
      </Modal>
      <Card style={{
                color: "white",
                background:
                  "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
              }}>
        <Card.Header>
        <select
            className="form- col-sm-3 text-primary p-2"
            id="val-skill"
            name="val-skill"
            placeholder="Select Search Item"
            defaultValue={searchItem}
            onChange={(event) => {
              setSearchItem(event.target.value);
            }}
          >
            {searchObject &&
              searchObject.map((val) => <option value={val}>{val}</option>)}
          </select>
          {searchItem === "Vehicle Type"?(
             <select
             className="form- col-sm-6 text-primary p-2"
             id="val-skill"
             name="val-skill"
             placeholder="Select Search Item"
             defaultValue={searchVehicleType}
             onChange={(event) => {
              setSearchVehicleType(event.target.value);
              searchByVehicleType(event.target.value)
             }}
           >
             {VehicleTypes &&
               VehicleTypes.map((val) => <option value={val}>{val}</option>)}
           </select>
          ):(
            <input
            type="text"
            className="form-control col-sm-6"
            placeholder={`search ${searchItem}`}
            onChange={(e) => {
              searchRider(e.target.value);
            }}
          />
          )}
          <button 
          onClick={()=>{window.location.reload()}}
          className="btn btn-primary">
            <i className="fa fa-refresh"></i>
          </button>
         
        </Card.Header>
        <Card.Body>
        <div id="job_data" className="dataTables_wrapper ">
          {spinner ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Table id="myTable" responsive className="text-white">
              <thead>
                <tr>
                  <th>
                    <strong>SL No.</strong>
                  </th>
                  <th>
                    <strong> NAME</strong>
                  </th>
                 
                  <th>
                    <strong>Phone No.</strong>
                  </th>
                  <th>
                    <strong>OnBoard ID</strong>
                  </th>

                  <th>
                    <strong>Vehicle</strong>
                  </th>
                  
                </tr>
              </thead>
              <tbody>
                {allriders &&
                  allriders.map((d, i) => (
                    <tr>
                      <td>
                        <strong>{i + 1}</strong>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <img
                            src={d.riderProfileImage}
                            className="rounded-lg mr-2"
                            width={40}
                            height={40}
                            alt=""
                          />{" "}
                          <span className="w-space-no">{d.riderFirstName}</span>
                        </div>
                      </td>
                     
                      <td>{d.riderPhone}</td>
                      <td>{d.riderOnboardingId?.CompanyCode}</td>
                      
                      <td>{d.RiderVehicleType.name}</td>
                      <td>
                        <Link to={`./rider-details/Rider/${d._id}`}>
                          <button className="btn btn-primary">View</button>
                        </Link>
                      </td>
                      {/* <td>
                        <Link to={`./edit-rider/${d._id}`}>
                          <button className="btn btn-primary">Edit</button>
                        </Link>
                      </td> */}
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
          {!allriders && (
            <Alert
              variant="success"
              className="alert-dismissible fade show text-center"
            >
              Zero Applied riders
            </Alert>
          )}
          <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
                <button onClick={()=>{
               
               getData(allriders.length)
               }} className="btn btn-primary ml-2">Next</button>
              </div>
            </div>
            </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default RiderApplied;
